import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "react-datepicker/dist/react-datepicker.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
